import { linePlot, periodInput } from "../definitionHelpers";
import { PALETTE } from "../palette";
import { trueRangeReader } from "../math/trueRange";
import { partialSumAt } from "../math/statistics";

// Vortex movement: from the previous low to the high (VM+) and from the previous high to the low (VM−)
const plusMoveReader = (bars) => (index) => (index < 1 ? NaN : Math.abs(bars[index].high - bars[index - 1].low));
const minusMoveReader = (bars) => (index) => (index < 1 ? NaN : Math.abs(bars[index].low - bars[index - 1].high));

/**
 * Vortex (research §1.4), as TV Vortex Indicator: the sums of VM+ and VM−
 * over Period divided by the sum of the true range. As in TV the sums are
 * partial on the first bars, so the lines start on the second bar.
 */
export default {
  id: "vortex",
  name: "Vortex",
  isOscillator: true,
  decimals: 4,
  inputs: [
    periodInput("period", "Period", 14, { min: 2, max: 100 }),
  ],
  plots: [
    linePlot("plus", "VI+", PALETTE.LIME),
    linePlot("minus", "VI−", PALETTE.RED),
  ],
  levels: [],

  calculate: (bars, { period }, series, fromIndex) => {
    const readPlus = plusMoveReader(bars);
    const readMinus = minusMoveReader(bars);
    const readTrueRange = trueRangeReader(bars);

    for (let index = fromIndex; index < bars.length; index += 1) {
      const trueRangeSum = partialSumAt(readTrueRange, index, period);

      series.plus[index] = partialSumAt(readPlus, index, period) / trueRangeSum;
      series.minus[index] = partialSumAt(readMinus, index, period) / trueRangeSum;
    }
  },
};
